(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["flavor-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const variantId = event.detail?.resource?.id;
    const productId = event.detail?.data?.productId;
    if (!variantId) return;

    document.querySelectorAll('[data-flavor-description]').forEach((wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return;
      if (productId && wrapper.dataset.productId !== String(productId)) return;

      const panes = wrapper.querySelectorAll(':scope > [data-variant-id]');
      if (!panes.length) return;

      panes.forEach((pane) => {
        if (pane instanceof HTMLElement) pane.hidden = pane.dataset.variantId !== String(variantId);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
